import "./drupal.scss";
import "@blueprintjs/popover2/lib/css/blueprint-popover2.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "filepond/dist/filepond.min.css";
import "react-phone-input-2/lib/style.css";
import React from "react";
import ReactDOM from "react-dom";
import { DrupalApp } from "./DrupalApp";
import { DrupalAppProvider } from "./DrupalAppProvider";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // query options
      refetchOnWindowFocus: false,
    },
    mutations: {
      // mutation options
    },
  },
});
ReactDOM.render(
  <DrupalAppProvider>
    <QueryClientProvider client={queryClient}>
      <DrupalApp />
    </QueryClientProvider>
    ,
  </DrupalAppProvider>,
  document.getElementById("root")
);
